// extracted by mini-css-extract-plugin
module.exports = {"UtilityBoxItem":"utility-box-item_UtilityBoxItem__J33lF","childWrapper":"utility-box-item_childWrapper__wyNV1","icon":"utility-box-item_icon__kVZn6"};